const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;

  return {
    container: {
      padding: 15,
      borderRadius: 15,
      background:
        'linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, rgba(153, 153, 153, 0.05) 100%)',

      boxShadow:
        '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.10) inset',
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
